/**
 * Zatvorí modal s animáciou
 * @param {Function} closeCallback - Funkcia ktorá nastaví show state na false
 */
let escListenerAttached = false;

const getTopmostOverlay = () => {
  if (typeof document === 'undefined') return null;

  const overlays = Array.from(document.querySelectorAll('.modal-overlay, .pdf-modal-overlay'));
  if (overlays.length === 0) return null;

  const visibleOverlays = overlays.filter((overlay) => {
    if (overlay.classList.contains('closing')) return false;
    return overlay.getClientRects().length > 0;
  });

  return visibleOverlays.length > 0 ? visibleOverlays[visibleOverlays.length - 1] : null;
};

const ensureEscListener = () => {
  if (escListenerAttached || typeof document === 'undefined') return;

  escListenerAttached = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const overlay = getTopmostOverlay();
    if (!overlay) return;

    event.preventDefault();
    event.stopPropagation();
    overlay.click();
  });
};

export const closeModalWithAnimation = (closeCallback, overlayTarget = '.modal-overlay') => {
  ensureEscListener();
  const overlay = typeof overlayTarget === 'string'
    ? document.querySelector(overlayTarget)
    : overlayTarget;
  if (overlay) {
    overlay.classList.add('closing');
    
    setTimeout(() => {
      closeCallback();
    }, 250);
  } else {
    closeCallback();
  }
};

ensureEscListener();
